import React from 'react'

const ErrorPage = () => {
  return (
    <div style={{padding:40, marginTop: 80}}>
     <h1 style={{fontSize: 40}}>e-commerce</h1>
     <br/>
     <br/>
     <br/>
     <br/>
     <p style={{fontWeight: 700, fontSize: 30}}>Our site hit a snag, but we're fixing it</p>
     <br/>
     <p>Please try again in a little while. In the meantime, you can call 1.888.888.8888</p>
    </div>
  )
}

export default ErrorPage
